import React, { FunctionComponent } from "react";
import styled from "styled-components";

import { Device } from "utils/device";
import { CL, CM } from "components/Typography";
import { colours } from "utils";
import MarketingLink from "../../MarketingLink";

const author = "Laura Cox, CFO, Sophia Webster";
const source = "Elevate Learner Testimonial   ";
const linkText = "Enquire now";

const ElevateLearnerQuote: FunctionComponent = () => {
  return (
    <>
      <S.Section>
        <S.Copy>
          <b>“I think Elevate is a very important course for women. </b>
          <br />
          <br />
          We can get so caught with up working and driving our careers, proving
          that we are capable of doing everything – professionals, mothers,
          wives etc, that we can get a bit lost in how best to move forward.
          <br />
          <br />
          The opportunity to meet other women in the same situation,{" "}
          <b>
            hear from other successful women and learn key skills to progress is
            invaluable and all areas are addressed in the course.”
          </b>
        </S.Copy>
        <S.Author>{author}</S.Author>
        <S.Source>{source}</S.Source>
        <MarketingLink
          href="/elevate"
          colour={colours.shell}
          linkText={linkText}
        />
      </S.Section>
      <S.Decoration />
    </>
  );
};

const S = () => {};

S.Section = styled.section`
  width: 100%;
  padding: 10%;
  display: flex;
  flex-direction: column;
  background: ${colours.marketingBlue};
  color: ${colours.shell};

  @media (min-width: ${Device.mobile}) {
    padding: 10% 30% 8% 10%;
  }

  @media (min-width: ${Device.desktop}) {
    padding: 8% 30% 6% 10%;
  }
`;

S.Copy = styled.p`
  font-size: 1.5rem;
  padding-bottom: 2rem;

  @media (min-width: ${Device.mobile}) {
    font-size: 2rem;
  }

  @media (min-width: ${Device.tablet}) {
    font-size: 2.5rem;
    padding-bottom: 4rem;
  }

  @media (min-width: ${Device.desktop}) {
    font-size: 3.5rem;
    padding-bottom: 6rem;
  }
`;
S.Author = styled(CM)`
  font-weight: 800;

  @media (min-width: ${Device.mobile}) {
    font-size: 2rem;
  }

  @media (min-width: ${Device.tablet}) {
    font-size: 2.5rem;
  }

  @media (min-width: ${Device.desktop}) {
    font-size: 3rem;
  }
`;

S.Source = styled(CL)`
  padding-bottom: 2rem;

  @media (min-width: ${Device.tablet}) {
    padding-bottom: 4rem;
  }

  @media (min-width: ${Device.desktop}) {
    padding-bottom: 6rem;
  }
`;

S.Decoration = styled.div`
  height: 70px;
  background-image: url("/images/marketing/navy-tessellation-2.svg");
  background-size: 400% auto;
  background-position: bottom;

  @media (min-width: ${Device.mobile}) {
    height: 80px;
    background-size: 300% auto;
  }

  @media (min-width: ${Device.tablet}) {
    height: 100px;
    background-size: 200% auto;
  }

  @media (min-width: ${Device.desktop}) {
    background-size: 100% auto;
  }
`;

export default ElevateLearnerQuote;
